import React from 'react';

import ReactDOM from 'react-dom';

import ReduxConnect from 'Demora/redux-connect';

import { Link } from 'react-router-dom';

import './Followers.css';

import Image from 'Demora/image';

import socialHttp from '../../../../utils/socialHttp';

import throttle from 'lodash/throttle';

const number_records = 20;

class Followers extends React.Component {
	constructor(props, context) {
		super(props, context);

		this.state = {
			coW: null,
			liW: null,
			liH: null,
			imS: 50,
			relationships:
				this.props.relationships == 'following' ? 'following' : 'followers',
		};
	}

	componentDidMount() {
		let obj = this.props.obj;

		let relationships = this.state.relationships;

		if (!this.props.feed[obj] || !this.props.feed[obj][relationships]) {
			socialHttp(
				'get',
				'/data/relationships/' +
					this.props.obj +
					'/' +
					relationships +
					'?first=20&socApiToken=' +
					new URLSearchParams(window.location.search).get('socApiToken')
			)
				.then((data) => {
					this.firstSetWidthOfUsers();
				})
				.catch((e) => {
					throw e;
				});
		}

		this.setWidthOfUsers();

		this.throttleResize = throttle(this.resetWidthOfUsers.bind(this), 750);
		window.addEventListener('resize', this.throttleResize);
	}

	firstSetWidthOfUsers() {
		this.setWidthOfUsers();
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.throttleResize);
	}

	componentDidUpdate() {
		this.setWidthOfUsers();
	}

	resetWidthOfUsers() {
		this.setState({
			coW: 'auto',
			liW: 'auto',
			liH: 'auto',
			imS: 50,
		});
	}

	setWidthOfUsers() {
		let props = this.props;

		let relationships = this.state.relationships;

		let feed = props.feed[props.obj];

		if (!feed || !ReactDOM.findDOMNode(this.refs['panel-followers'])) {
			return;
		}

		let coW = ReactDOM.findDOMNode(this.refs['panel-followers']).offsetWidth;

		if (!coW) {
			return;
		}

		coW += 'px';

		let imageSizes = [50, 100, 200];

		if (this.state.coW != coW && Object.keys(feed[relationships]).length > 0) {
			coW = parseFloat(coW);

			let el = window.getComputedStyle(
				ReactDOM.findDOMNode(this.refs['card-body']),
				null
			);

			let pad =
				parseFloat(el.getPropertyValue('padding-left')) +
				parseFloat(el.getPropertyValue('padding-right'));

			coW = coW - pad - 2;

			if (coW > 400) {
				coW = 400;
			}

			let num = parseInt(coW / 100) + 1;

			let liW = coW / num;

			if (liW < 50) {
				liW = 50;
			}

			let imS;

			imageSizes.map((i) => {
				if (!imS && liW <= i) {
					imS = i;
				}
			});

			let dd = Math.abs(parseFloat(this.state.coW) - parseFloat(coW + pad));

			if (dd < 10) {
				return;
			}

			this.setState({
				coW: coW + pad + 2 + 'px',
				liW: liW,
				imS: imS,
				liH: liW + 25,
			});
		}
	}

	showMoreFollowers = () => {
		const { obj, feed } = this.props;

		const relationships = this.state.relationships;

		const followers = feed[obj][relationships];

		const before = followers.i.startCursor;

		socialHttp(
			'get',
			'/data/relationships/' +
				obj +
				'/' +
				relationships +
				'?before=' +
				before +
				'&first=20'
		).catch((e) => {
			throw e;
		});
	};

	render() {
		let that = this;

		let obj = this.props.obj;

		let relationships = this.state.relationships;

		if (
			!this.props.feed[obj] ||
			!this.props.feed[obj][relationships] ||
			!this.props.users[obj]
		) {
			return null;
		}

		let followers = this.props.feed[obj][relationships];

		let followKeys = Object.keys(followers.p).filter((a) => {
			return !followers.p[a].d;
		});

		let next = followers.i.total - followKeys.length;

		return (
			<div className='row'>
				<div className='col-lg-12'>
					<div
						className='card panel-followers mx-auto'
						ref='panel-followers'
						style={{ width: that.state.coW }}
					>
						<div className='card-header'>
							<Link
								to={'/profile/followers/' + obj}
								className='pull-xs-right btn view_all_button d-none'
							>
								<span className='view_all_text'>View all&nbsp;</span>
								<i className='far fa-share-square'></i>
							</Link>
							<i className='fa fa-users'></i>&nbsp;
							{relationships.charAt(0).toUpperCase() + relationships.slice(1)}
							&nbsp;
							<span>
								{followers.i.total > 0 ? '(' + followers.i.total + ')' : ''}
							</span>
						</div>
						<div className='card-body text-center' ref='card-body'>
							{followKeys.length == 0 ? (
								<div className='text-center'>
									{this.props.users[obj].first_name}
									{relationships == 'followers'
										? " doesn't have any followers"
										: " isn't following anyone"}
									.
								</div>
							) : (
								<ul className='followers'>
									{followKeys.map(function (key, index) {
										let user = that.props.users[key];

										if (!user) {
											return null;
										}

										return (
											<li
												className='text-center'
												key={index}
												style={{
													width: that.state.liW + 'px',
													height: that.state.liH + 'px',
												}}
											>
												<Link to={'/profile/' + key}>
													<img
														src={Image(user.image, that.state.imS)}
														title={user.first_name}
														className='img-responsive tip rounded'
													/>
													<div className='first_name'>{user.first_name}</div>
												</Link>
											</li>
										);
									})}
								</ul>
							)}

							{followKeys.length > 0 && next > 0 && (
								<div className='col-12 text-center'>
									<button
										className='btn btn-primary btn-sm'
										onClick={this.showMoreFollowers}
									>
										More...
									</button>
								</div>
							)}
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default ReduxConnect(Followers, {
	user: 'user',
	feed: 'feed',
	users: 'users',
});
